export const NEXT_PUBLIC_SERVER_FILE_ENDPOINT = `${process.env.NEXT_PUBLIC_SERVER_ENDPOINT}/file`

export const DEFAULT_META_IMAGE_URL = "https://storage.googleapis.com/myskillshaala-web.appspot.com/public/meta-tag-placeholder.jpg"

export const DEFAULT_META_DESCRIPTION = ""
